import { render, staticRenderFns } from "./EncuestaEstadisticasProlipa.vue?vue&type=template&id=ffd1bda6&scoped=true"
import script from "./EncuestaEstadisticasProlipa.vue?vue&type=script&lang=js"
export * from "./EncuestaEstadisticasProlipa.vue?vue&type=script&lang=js"
import style0 from "./EncuestaEstadisticasProlipa.vue?vue&type=style&index=0&id=ffd1bda6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd1bda6",
  null
  
)

export default component.exports